export function buildURL(base, qsArgs = {}) {
  const queryString = Object.keys(qsArgs)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(qsArgs[k])}`)
    .join('&');

  return [base, queryString].join('?');
}
